import { Stack } from "react-bootstrap";
import { Term } from "../../utils/interfaces";
import ListSorter from "../ListSorter/ListSorter"

type Step3Props = {
  onToggle: (item: Term) => void;
  topList: Array<Term>;
  topCategory: string | undefined;
  label: string;
};

const Step3: React.FC<Step3Props> = ({
  topList,
  label,
  topCategory,
  onToggle,
}) => {
  const selectedList = topList.filter(item => item.selected)
  return (
    <Stack gap={3}>
      <h3>
        Select your top 5 {label} from the "{topCategory}" pile ({selectedList.length}/5)
      </h3>
      <div>
        <ListSorter items={topList} onToggle={onToggle} maxItems={5} />
      </div>
    </Stack>
  );
};

export default Step3;
